import { useEffect } from 'react';
import { handleScreenResize } from '../helpers/handleScreenResize';

// Handles dynamic resizing of the screen.
export function useScreenResizing(setScreenWidth, setScreenHeight) {
  useEffect(() => {
    return handleScreenResize(setScreenWidth, setScreenHeight);
  }, [setScreenWidth, setScreenHeight]);
}
